module.exports = __webpack_public_path__ + "img/customer-a-055.cf67be04.png";